import { BAKED_AFTER_PASSOVER_LABEL } from "@/lib/utils";

/** מוצר עם תווית "נאפה לאחר הפסח" */
export function isBakedAfterPassoverProduct(product) {
  return !!(product?.isBakedAfterPassover || product?.is_baked_after_passover);
}

/**
 * האם טוקן חיפוש מתייחס לתווית "נאפה לאחר הפסח" (כולל נלפ, ליקוט/בליקוט, חלקי המשפט וכו').
 * לא תלוי במוצר — רק בטקסט החיפוש.
 */
export function tokenRefersToBakedAfterPassover(rawToken) {
  const pl = String(rawToken ?? "").trim().toLowerCase();
  if (pl.length < 2) return false;

  const label = BAKED_AFTER_PASSOVER_LABEL.toLowerCase();
  if (label.includes(pl)) return true;

  const compact = label.replace(/\s+/g, "");
  if (compact.includes(pl)) return true;

  const shortcuts = [
    "נלפ",
    "נאלפ",
    "נאפלאחרהפסח",
    "לאחרהפסח",
    "ליקוט",
    "בליקוט",
  ];
  for (const s of shortcuts) {
    if (pl === s) return true;
    if (s.length >= 2 && pl.length >= 2 && (s.startsWith(pl) || pl.startsWith(s))) return true;
  }

  const words = label.split(/\s+/).filter((w) => w.length >= 2);
  for (const w of words) {
    if (w.includes(pl) || (pl.length >= 2 && w.startsWith(pl))) return true;
  }

  return false;
}

/**
 * מחלק טוקני חיפוש: כאלה שמתייחסים ל"נאפה לאחר הפסח" מול השאר (שם, מק״ט וכו').
 */
export function partitionSearchPartsForBakedAfter(parts) {
  const baked = [];
  const rest = [];
  for (const p of parts) {
    if (tokenRefersToBakedAfterPassover(p)) baked.push(p);
    else rest.push(p);
  }
  return { bakedTokens: baked, restTokens: rest };
}
